import { H4, IconAnchorButton, LinkButton } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ContactUpdateInquiryContactDiffResource } from "../../../../shared/types/contactUpdateInquiry";

const Wrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr max-content;
	gap: ${({ theme }) => theme.spacing(4)};
	align-items: start;
	padding: ${({ theme }) => theme.spacing(4)};
`;

const Actions = styled.div`
	display: grid;
	grid-auto-flow: column;
	grid-auto-columns: max-content;
	gap: ${({ theme }) => theme.spacing(2)};
	align-items: center;
`;

interface Props {
	contact: ContactUpdateInquiryContactDiffResource;
}

export const ContactUpdateNameCard: FC<Props> = ({ contact }) => {
	const { t } = useTranslation();
	const primaryEmail = contact.emails.find((a) => a.currentContact.isPrimary);
	const primaryPhone = contact.phones.find((a) => a.currentContact.isPrimary);

	const firstName = contact.attributes.find(
		(a) => a.currentContact.type === "column" && a.currentContact.entityType === "firstName",
	)?.currentContact.value;
	const lastName = contact.attributes.find(
		(a) => a.currentContact.type === "column" && a.currentContact.entityType === "lastName",
	)?.currentContact.value;

	return (
		<Wrapper>
			<div>
				<H4>{t("Contact")}</H4>
				<div>
					{firstName} {lastName}
				</div>
				{primaryEmail && <div>{primaryEmail.currentContact.email}</div>}
			</div>
			<Actions>
				{primaryEmail && (
					<IconAnchorButton
						title={t("Send email to contact")}
						href={`mailto:${primaryEmail.currentContact.email}`}
						iconSrc="/mail.svg"
						size="small"
					/>
				)}
				{primaryPhone && (
					<IconAnchorButton
						title={t("Call contact")}
						href={`tel:${primaryPhone.currentContact.phoneNumber}`}
						iconSrc="/tel.svg"
						size="small"
					/>
				)}
				<LinkButton size="small" to={`/contacts/${contact.contactId}`}>
					{t("To contact")}
				</LinkButton>
			</Actions>
		</Wrapper>
	);
};
